import React from "react";

import UploadMenuItem from "./upload_menu_item";

function SetDocumentTypeMenu(props) {
  return (
    <div>
      {props.documentTypes.map(dt => (
        <UploadMenuItem
          key={dt.id}
          id={dt.id}
          selectedItemId={props.selectedItemId}
          selectItem={props.selectItem}
        >
          {dt.name}
        </UploadMenuItem>
      ))}
    </div>
  );
}

export default SetDocumentTypeMenu;
